import { BaSeInput, BaSeTheme, useDebounce } from '@base/react';
import React, { useState } from 'react';

// import { Container } from './styles';

function SearchInput({ setFilter }) {
  const [search, setSearch] = useState('');

  const searchDebounce = useDebounce(search, 1200);

  React.useEffect(() => {
    setFilter({ fieldOfResearch: searchDebounce });
  }, [searchDebounce, setFilter]);

  return (
    <>
      <BaSeInput
        label="‎ "
        width={'50%'}
        iconButton={{
          typeButton: 'base-icon',
          name: 'search-alt',
          color: BaSeTheme.colors.institucionais.cinzaSebrae10,
        }}
        placeholder="Pesquisar por nome, e-mail, CPF e telefone"
        onChange={(e) => {
          setSearch(e);
        }}
        value={search}
      />
    </>
  );
}

export default SearchInput;
